module.exports = __webpack_public_path__ + "static/media/avatar.7257a1a9.jpg";